import parseIntFromStr from "../parseIntFromStr";

export default function filterList(array){
    return array?.map(item => parseIntFromStr(item)) || [];
}